import { IGetAllServicesRequest, IGetServiceByRequest } from "../../../types";

const API_PREFIX = "/services";

export const getGetAllServicesEndpoint = (queries: IGetAllServicesRequest) => {
  const { page, pageSize, search, sortBy, sortOrder, category, staffId, equipmentId } = queries;
  
  let queryParams = [];
  
  if (page && pageSize) {
    queryParams.push(`page=${page}`);
    queryParams.push(`pageSize=${pageSize}`);
  }
  
  if (search) queryParams.push(`search=${search}`);
  if (sortBy) queryParams.push(`sortBy=${sortBy}`);
  if (sortOrder) queryParams.push(`sortOrder=${sortOrder}`);
  
  // Dodavanje novih filtara
  if (category && category.length > 0) {
    category.forEach(cat => queryParams.push(`category[]=${cat}`));
  }
  
  if (staffId && staffId.length > 0) {
    staffId.forEach(staff => queryParams.push(`staffId[]=${staff}`));
  }
  
  if (equipmentId && equipmentId.length > 0) {
    equipmentId.forEach(equip => queryParams.push(`equipmentId[]=${equip}`));
  }
  
  return `${API_PREFIX}${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
}

export const getGetServiceByEndpoint = (getServiceByQueries: IGetServiceByRequest) =>
  `${API_PREFIX}/getBy?prop=${getServiceByQueries.prop}&value=${getServiceByQueries.value}`;
export const getUpdateServiceEndpoint = (serviceId: string) => `${API_PREFIX}/${serviceId}`;
export const getDeleteServiceEndpoint = (serviceId: string) => `${API_PREFIX}/${serviceId}`;
export const getUploadServiceImageEndpoint = (serviceId: string) =>
  `${API_PREFIX}/${serviceId}/image`;

export const getCreateServiceEndpoint = () => `${API_PREFIX}`;
